import { object, string } from 'yup';

const loginSchema = object({
	lastName: string()
		.required('Last name is required')
		.max(20, 'Last name must be at most 20 characters'),
	badgeNumber: string()
		.required('Badge number is required')
		.max(15, 'Badge number must be at most 15 characters')
		.matches(/^\d+$/, 'Badge number must be numeric'),
}).required();

export default loginSchema;
